export const getUrlParams = () => {
  const href = decodeURI(window.location.href)
  const { searchParams } = new URL(href)

  const params: Record<string, string> = {}
  for (const [key, value] of searchParams.entries()) {
    params[key] = value
  }

  return params
}
